import { countOccurrences } from '../countOccurences'
import { isCounty } from '../isCounty'
import { isZipCode } from '../isZipCode'

export const isCity = (slug: string): boolean => {
  return (countOccurrences(slug, '-') >= 1) && (!isCounty(slug) && !isZipCode(slug));
}
